import { render, staticRenderFns } from "./search-box-processing.vue?vue&type=template&id=5fe8f472&scoped=true"
import script from "./search-box-processing.vue?vue&type=script&lang=js"
export * from "./search-box-processing.vue?vue&type=script&lang=js"
import style0 from "./search-box-processing.vue?vue&type=style&index=0&id=5fe8f472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe8f472",
  null
  
)

export default component.exports